import Base from '@studiometa/js-toolkit/abstracts/Base';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { isDev } from '../config';

gsap.registerPlugin(ScrollTrigger);

/**
 *    ScrollingCarousel class.
 */
export default class ScrollingCarousel extends Base {
  /**
   * Class config.
   * @return {Object}
   */
  get config() {
    return {
      name: 'ScrollingCarousel',
      log: isDev(),
      options: {
        direction: {
          type: String,
          default: 'left',
        },
      },
    };
  }

  /**
   * Mounted
   * @return {void}
   */
  mounted() {
    const lastPosition =
      -this.$refs.items[0].clientWidth * this.$refs.items.length + this.$el.clientWidth;
    gsap
      .timeline({
        scrollTrigger: {
          trigger: this.$el,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
        },
      })
      .fromTo(
        this.$refs.container,
        {
          x: this.$options.direction === 'right' ? lastPosition : 0,
        },
        {
          x: this.$options.direction === 'right' ? 0 : lastPosition,
          duration: 1,
        }
      );
  }
}
